<app-header></app-header>
<app-progress-bar [planeColor]="'#0045b6'"></app-progress-bar>
<app-search-results></app-search-results>
<app-footer></app-footer>